import { InjectionToken } from '@angular/core';
import { IImageDialogData } from './i-image-dialog-data.interface';

export const IMATE_DIALOG_DATA = new InjectionToken<IImageDialogData[]>('IMAGE_DIALOG_DATA');
